<template>
  <div class="create-class-modal">
    <div class="create-class-form">
      <a
        data-w-id="ead5b36a-f1b3-c369-6039-98d62b053621"
        @click="cancel"
        href="#"
        class="link-block-5 w-inline-block"
      >
        <img
          src="@/assets/timeslot-images/cancelIconNew.svg"
          loading="lazy"
          alt=""
        />
      </a>
      <div class="div-block-52">
        <h1 class="modal-heading">Create a class</h1>
      </div>
      <div class="field">
        <div class="text-block-48">Topic</div>
        <!--        <input type="text" v-model="createClassModel.groupSessionTopic" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Enter a topic" id="field-5" required="">-->
        <FormulateInput
          type="text"
          v-model="createClassModel.groupSessionTopic"
        />
      </div>
      <div style="display: flex; justify-content: space-between; ">
        <div class="field" style="width:48%;">
          <div class="text-block-48">Date</div>
          <FormulateInput type="date" v-model="classDate" />
          <!--        <input type="text" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Select start date" id="field-5" required="">-->
        </div>
        <div class="field" style="width:48%;">
          <div class="text-block-48">Max. no of Students</div>
          <FormulateInput
            type="number"
            v-model="createClassModel.groupSessionMaxAttendance"
          />
          <!--          <input type="text" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Select end date" id="field-5" required="">-->
        </div>
      </div>
      <div style="display: flex; justify-content: space-between; ">
        <div class="field" style="width:48%;">
          <div class="text-block-48">Start time</div>
          <FormulateInput type="time" />
          <!--          <input type="text" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Select end date" id="field-5" required="">-->
        </div>
        <div class="field" style="width:48%;">
          <div class="text-block-48">End time</div>
          <FormulateInput type="time" />
          <!--          <input type="text" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Select end date" id="field-5" required="">-->
        </div>
      </div>
      <div class="field">
        <div class="text-block-48">Set Price</div>
        <FormulateInput type="number" />
        <!--          <input type="text" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Set price" id="field-5" required="">-->
      </div>

      <!--          <input type="text" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Set price" id="field-5" required="">-->

      <div class="field">
        <div class="text-block-48">Description</div>
        <FormulateInput type="textarea" />
        <!--        <input type="text" class="select-field w-input" maxlength="256" name="field-5" data-name="Field 5" placeholder="Enter a topic" id="field-5" required="">-->
      </div>

      <!--      <div class="switch-wrapper">-->
      <!--        <div class="div-block-168">-->
      <!--          <div class="div-block-175">-->
      <!--            <div class="div-block-55-copy">-->
      <!--              <div class="form-block-6 w-form">-->
      <!--                <form id="email-form" name="email-form" data-name="Email Form" method="get"><select id="Select-frequency-2" name="Select-frequency-2" data-name="Select Frequency 2" class="select-field w-select">-->
      <!--                  <option value="">Frequency</option>-->
      <!--                  <option value="First">Weekly</option>-->
      <!--                  <option value="Second">Monthly</option>-->
      <!--                </select></form>-->
      <!--                <div class="w-form-done">-->
      <!--                  <div>Thank you! Your submission has been received!</div>-->
      <!--                </div>-->
      <!--                <div class="w-form-fail">-->
      <!--                  <div>Oops! Something went wrong while submitting the form.</div>-->
      <!--                </div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--            <div class="form-block-5 w-form">-->
      <!--              <form id="email-form" name="email-form" data-name="Email Form" method="get"><input type="text" class="select-field-price w-input" maxlength="256" name="field-3" data-name="Field 3" placeholder="Enter price" id="field-3" required=""></form>-->
      <!--              <div class="w-form-done">-->
      <!--                <div>Thank you! Your submission has been received!</div>-->
      <!--              </div>-->
      <!--              <div class="w-form-fail">-->
      <!--                <div>Oops! Something went wrong while submitting the form.</div>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--          <div>-->
      <!--            <a href="#" class="link-20">+ Add more plan</a>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div
        data-w-id="ead5b36a-f1b3-c369-6039-98d62b05366a"
        class="button-12 w-button"
      >
        Proceed
      </div>
    </div>
    <!--    <div class="class-created">-->
    <!--      <a data-w-id="ead5b36a-f1b3-c369-6039-98d62b05366f" href="#" class="link-block-5 w-inline-block">-->
    <!--        <img src="@/assets/timeslot-images/cancelIconNew.svg" loading="lazy" alt="">-->
    <!--      </a>-->
    <!--      <img src="@/assets/timeslot-images/animation_500_l3vkfkxp.gif" loading="lazy" width="170" alt="">-->
    <!--      <div class="text-block-copy">-->
    <!--        Successful-->
    <!--      </div>-->
    <!--      <div class="text-block-3-copy">-->
    <!--        You have successfully created a class-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";

export default {
  name: "CreateClassModal",
  props: {
    cancel: Function
  },
  data() {
    return {
      createClassModel: GroupSessionRequest.create
    };
  }
};
</script>

<style scoped>
.field {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
</style>
